import { Moon, Sun } from "lucide-react";
import { motion } from "framer-motion";
import { useTheme } from "../../contexts/ThemeContext";

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <motion.button
      onClick={toggleTheme}
      aria-label="Toggle theme"
      whileHover={{ scale: 1.1, rotate: 15 }}
      whileTap={{ scale: 0.9 }}
      className="
        relative w-12 h-12 rounded-full flex items-center justify-center
        transition-all shadow-lg hover:shadow-xl

        /* Light mode (unchanged vibe) */
        bg-gradient-to-br from-blue-500 to-purple-600

        /* Dark mode (new brand look) */
        dark:bg-gradient-to-br dark:from-zinc-900 dark:via-zinc-800 dark:to-zinc-900
        dark:ring-2 dark:ring-red-500/30
      "
    >
      {/* Moon (dark mode icon) */}
      <motion.div
        initial={false}
        animate={{
          scale: theme === "dark" ? 1 : 0,
          rotate: theme === "dark" ? 0 : 180
        }}
        transition={{ duration: 0.3 }}
        className="absolute"
      >
        <Moon className="w-5 h-5 text-amber-400" />
      </motion.div>

      {/* Sun (light mode icon) */}
      <motion.div
        initial={false}
        animate={{
          scale: theme === "light" ? 1 : 0,
          rotate: theme === "light" ? 0 : 180
        }}
        transition={{ duration: 0.3 }}
        className="absolute"
      >
        <Sun className="w-5 h-5 text-yellow-300" />
      </motion.div>
    </motion.button>
  );
};
